<div class="login-page-wrapper">
    <h1 class="main-heading">Forgot Password</h1>
    <p class="description-text">Enter your email address and we will send you a code to reset your password.</p>
    
    <form [formGroup]="ForgetEmailForm" (ngSubmit)="onSubmitForm($event)" class="form-container">
        <div class="fields-container">
            <div class="mb-3 email-section">
                <label for="email" class="email-label form-label font-weight-bold">Email</label>
                <input type="email" class="email-inpute form-control" id="email" formControlName="Email"
                    placeholder="Enter your Email">
                <div *ngIf="ForgetEmailForm.get('Email')?.invalid && (ForgetEmailForm.get('Email')?.dirty || ForgetEmailForm.get('Email')?.touched)"
                    class="text-danger">
                    <small *ngIf="ForgetEmailForm.get('Email')?.errors?.['required']">Email is required.</small>
                    <small *ngIf="ForgetEmailForm.get('Email')?.errors?.['email']">Enter a valid email.</small>
                    <small *ngIf="ForgetEmailForm.get('Email')?.errors?.['custom']">{{ ForgetEmailForm.get('Email')?.errors?.['custom']
                        }}</small>
                </div>
            </div>
            <div class="submition d-flex justify-content-center">
                <button type="submit" class="submit-btn btn btn-primary">Continue</button>
            </div>

            <div class="back-to-login mt-3 d-flex justify-content-center">
                <a [routerLink]="['/', AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.LOGIN]"
                    class="forgot-password-link text-decoration-none">Back to Login</a>
            </div>
        </div>
    </form>
</div>